<template>
  <div>
    <HomepageTreeView></HomepageTreeView>
  </div>

</template>

<script>

import piincHttp from '@/util/configureAxios.js';
import HomepageTreeView from '@/components/HomepageTreeView.vue'

export default {
  name: 'MaintenanceDashboard',
  data: function() {
    return {
      
    }
  },
  components: {
    HomepageTreeView
  },
  computed: {
    getClient() {
      return this.$store.state.client
    }
  },
  watch: {
    // Watch when client changes in store and trigger api reload
    getClient: function () {
    }
  },
  methods: {

  },
  created () {
    if (this.getClient && this.getClient.slug) {

    }
  }
}
</script>
